export enum CarouselLayout {
  Landscape = 'Landscape',
  Portrait = 'Portrait',
  Collection = 'Collection',
  Top10 = 'Top10',
  Expandable = 'Expandable',
}

export enum MarketingItemLayout {
  CTA_LEFT = 'LEFT',
  CTA_RIGHT = 'RIGHT',
  TRENDING_LEFT = 'TRENDING_LEFT',
  TRENDING_RIGHT = 'TRENDING_RIGHT',
  EMAIL_CENTERED = 'EMAIL_CENTERED',
  EMAIL_LEFT = 'EMAIL_LEFT',
  EMAIL_RIGHT = 'EMAIL_RIGHT',
  MULTIPLE_CONTENT_LANDSCAPE = 'MULTIPLE_CONTENT_LANDSCAPE',
  MULTIPLE_CONTENT_PORTRAIT = 'MULTIPLE_CONTENT_PORTRAIT',
  DETAILED_PAGE_BANNER_LEFT = 'DETAILED_PAGE_BANNER_LEFT',
  DETAILED_PAGE_BANNER_CENTER = 'DETAILED_PAGE_BANNER_CENTER',
  DETAILED_PAGE_BANNER_RIGHT = 'DETAILED_PAGE_BANNER_RIGHT',
}

export enum StudiosTrayLayout {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export enum HeroLayout {
  HERO = 'Hero',
}

export enum GenericLayout {
  TwoCards = 'GenericLayoutTwoCards',
  ThreeCards = 'GenericLayoutThreeCards',
  FourCards = 'GenericLayoutFourCards',
}

export enum BannersWithCTALayout {
  TwoCards = 'BannersWithCTATwoCard',
  ThreeCards = 'BannersWithCTAThreeCard',
}

export type DomainLayout = CarouselLayout | MarketingItemLayout | StudiosTrayLayout | HeroLayout | GenericLayout | BannersWithCTALayout;
